import { FIELD } from "../../constants/formConstants";

const required = (field) => {
  if (!field.value) {
    return false;
  }
  return true;
};
required.id = "required";

const exactLength = (field) => {
  if (field.exactLength) {
    if (field.value.length === field.exactLength) {
      return true;
    }
    return false;
  }
  return false;
};
exactLength.id = "exactLength";

const maxLength = (field) => {
  if (field.maxLength) {
    if (field.value.length > field.maxLength) {
      return false;
    }
  }
  return true;
};
maxLength.id = "maxLength";

const minLength = (field) => {
  if (field.minLength) {
    if (field.value.length < field.minLength) {
      return false;
    }
  }
  return true;
};
minLength.id = "minLength";

// separate method, independent of field object
const isEmailValid = (email) => {
  if (/^\w+([+.-]?\w+)*@\w+([.-]?\w+)*(\.\w+)+$/.test(email)) {
    return true;
  }
  return false;
};

const email = (field) => {
  return isEmailValid(field.value);
};
email.id = "email";

const password = (field) => {
  if (/^(?=.*[A-Z])(?=.*\d)[A-Za-z\d$@_!#$]{8,20}$/.test(field.value)) {
    return true;
  }
  return false;
};
password.id = "password";

const confirmField = (field) => {
  if (field.value === field.confirmField.value) {
    return true;
  }
  return false;
};
confirmField.id = "confirmField";

const zipcode = (field) => {
  if (/^\d{5}$/.test(field.value)) {
    return true;
  }
  return false;
};
zipcode.id = "zipcode";

const phonenumber = (field) => {
  if (
    /^\([0-9]{3}\) [0-9]{3}-[0-9]{4}$/.test(field.value) ||
    /^[0-9]{10}$/.test(field.value)
  ) {
    return true;
  }
  return false;
};
phonenumber.id = "phonenumber";

export default {
  [FIELD.VALIDATIONS.REQUIRED]: required,
  [FIELD.VALIDATIONS.MAX_LENGTH]: maxLength,
  [FIELD.VALIDATIONS.MIN_LENGTH]: minLength,
  [FIELD.VALIDATIONS.EXACT_LENGTH]: exactLength,
  [FIELD.VALIDATIONS.EMAIL]: email,
  [FIELD.VALIDATIONS.PASSWORD]: password,
  [FIELD.VALIDATIONS.CONFIRM_FIELD]: confirmField,
  [FIELD.VALIDATIONS.ZIPCODE]: zipcode,
  [FIELD.VALIDATIONS.PHONENUMBER]: phonenumber,
};

// to call independent of field object
export { isEmailValid };
